import Head from 'next/head'
import React, { useEffect, useState } from 'react'
import { Box, Container, Grid, Typography, Paper } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import useLazyState from '../../../hooks/useLazyState'
import LoadMask from '../../../lib/react-storefront/LoadMask'
import getServerSideAPIProps from '../../../props/getServerSideAPIProps'
import LocationOnIcon from '@material-ui/icons/LocationOn'
import ResponsiveTiles from '../../../components/layout/ResponsiveTiles'
import Slider from 'react-slick'
import isEmpty from 'lodash/isEmpty'
// Import css files
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { useRouter } from 'next/router'
import AboutBackground from '../../../assets/images/background.png'
import ProductItem from '../../../components/product/ProductItem'
import AlertComponent from '../../../components/Alert'
const CryptoJS = require('crypto-js');
const styles = () => ({
  cusbtnbgcolor: c => ({
    background: c.backgroundColor,
    color: c.color,
  }),
})

const useStyles = makeStyles(styles)

export default function Index(lazyProps) {
  let router = useRouter()
  let { storeSlug } = router.query
  const getCarouselSettings = (slideCount) => ({
    dots: slideCount > 1,
    infinite: slideCount > 1,
    speed: 500,
    autoplaySpeed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: slideCount > 1,
    pauseOnHover: true,
  })
  const [joinEmail, setjoinEmail] = useState('')
  const [addToCartInProgress, setAddToCartInProgress] = useState(false)

  const [state, updateState] = useLazyState(lazyProps)

  let themeColor =
    state && state.hasOwnProperty('pageData')
      ? state.pageData &&
        state.pageData.hasOwnProperty('storeconfig') &&
        state.pageData.storeconfig &&
        state.pageData.storeconfig.web_theme_color
        ? state.pageData.storeconfig.web_theme_color + ' !important'
        : '#1e3041 !important'
      : '#1e3041 !important'

  let fontColor =
    state.pageData &&
    state.pageData.hasOwnProperty('storeconfig') &&
    state.pageData.storeconfig.hasOwnProperty('web_theme_font_color')
      ? state.pageData.storeconfig.web_theme_font_color
      : '#FFFFFF'
  const mystyle = {
    backgroundColor: `${themeColor}`,
    color: `${fontColor}` + ' !important',
  }

  const classes = useStyles(mystyle)
  const [emailMessage, setEmailMessage] = useState(null)
  const [errorType, setErrorType] = React.useState('success')

  

  const subscribe = async () => {
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    if (joinEmail != '' && re.test(joinEmail)) {
      let res = await fetch('/api/store/' + storeSlug + '/maillist', {
        method: 'post',
        body: JSON.stringify({
          email: joinEmail,
        }),
      })
      await res.json()
      setErrorType('success')
      setjoinEmail('')
      setEmailMessage('You have successfully subscribed our newsletter!')
    } else {
      setErrorType('error')
      setEmailMessage('Please enter a valid email address')
    }
  }
  const handleCloseError = () => {
    setEmailMessage(null)
  }
  useEffect(() => {
    if (storeSlug) {
      (async function fetchData() {
          const res = await fetch(`/api/store/${storeSlug}`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
            },
          })
          const data = await res.json()
          updateState(prevState => ({ ...prevState, pageData: data.pageData }))
      })()
    }
  }, [storeSlug])

  let storeConfig = state?.pageData?.storeconfig || {}

  let storeconf =  [storeConfig?.bizname , storeConfig?.bizaddress , storeConfig?.bizsuburb ,storeConfig?.bizstate , storeConfig?.bizpostcode, storeConfig?.bizcountry ]  
  storeconf = storeconf.filter(element => element);
  return (
    <>
      {state.loading || isEmpty(state.pageData) ? null : (
        <Head>
          <title>{state.pageData.title}</title>
        </Head>
      )}
      <div>
        <AlertComponent message={emailMessage} type={errorType} close={handleCloseError} hideTime={3}/>
        {state.loading || isEmpty(state.pageData) ? (
          <LoadMask transparent />
        ) : (
          <div className={classes.main}>
            {state.pageData?.carousel?.length > 0 && (
              <Slider {...getCarouselSettings(state.pageData.carousel.length)}>
                {state.pageData.carousel.map((data, i) => (
                  <div key={i}>
                    <img
                      style={{ width: '100%', height: 'auto' }}
                      src={data.media}
                      title="slider image"
                    />
                  </div>
                ))}
              </Slider>
            )}
            <Container maxWidth="lg">
              <Box mt={3}>
                <Typography
                  className="head-lg"
                  variant="h3"
                  component="h1"
                  align="center"
                  gutterBottom
                  color="primary"
                >
                  Trending Items
                </Typography>
                <Grid container justifyContent="center" className="trending-items">
                  {
                    <ResponsiveTiles
                      cols={{
                        lg: state.pageData.products.length < 5 ? 4 : 5,
                        xl: state.pageData.products.length < 5 ? 4 : 5,
                      }}
                    >
                      {state.pageData.products.map(
                        (product, i) =>
                          ((product && product.total_stocks > 0) ||
                            storeConfig.outofstock == 'ignoreinventorylevel') && (
                            <ProductItem key={product.id} product={product} index={i} addToCartInProgress={addToCartInProgress} setAddToCartInProgress={setAddToCartInProgress}/>
                          )
                      )}
                    </ResponsiveTiles>
                  }
                </Grid>
              </Box>
            </Container>
            <div className="about-sec" style={{ backgroundImage: `url(${AboutBackground})` }}>
              <h2>About {storeConfig.bizname}</h2>
              <p>{storeConfig.bizabout}</p>
              <div className="grid-blk">
                <div className={classes.root}>
                  {storeConfig.timings && (
                    <Grid container justifyContent="center" spacing={4}>
                      {storeConfig.timings.map((data, i) => (
                        <Grid key={i} item xs={12} sm={6} lg={4}>
                          <Paper className={classes.paper}>
                            <h3>
                              {data.sday} - {data.eday}
                            </h3>
                            <div>
                              {data.stime} to {data.etime}
                            </div>
                          </Paper>
                        </Grid>
                      ))}
                    </Grid>
                  )}
                </div>
              </div>
            </div>
            <Container maxWidth="lg">
              <div className="map-sec">
                <Box mt={3}>
                  <Grid
                    style={{ backgroundColor: '#F3F3F3' }}
                    container
                    spacing={0}
                    justifyContent="center"
                  >
                    <Grid item sm={12} md={6}>
                      <Box className="map-address" pt={'150px'} height={'400px'}>
                        <Typography align="center">
                          <LocationOnIcon style={{ fontSize: '50px' }}></LocationOnIcon>
                        </Typography>

                        <Typography align="center" variant="h5">
                          Visit us in {storeConfig.bizsuburb}
                        </Typography>
                        <Typography align="center" variant="h6">                        
                          {storeconf.join(', ').split('')}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid className="full-wdth" item sm={12} md={6}>
                      <iframe
                        src={storeConfig.bizmapurl || (storeConfig.searchbizaddress ? `https://maps.google.com/maps?q=${encodeURIComponent((storeConfig.bizname ? storeConfig.bizname + ', ' : '') + storeConfig.searchbizaddress)}&output=embed` : (storeConfig.bizlatitude && storeConfig.bizlongitude ? `https://maps.google.com/maps?q=${storeConfig.bizlatitude},${storeConfig.bizlongitude}&output=embed` : ''))}
                        style={{ width: '100%', height: '400px', border: 0 }}
                        allowFullScreen=""
                        loading="lazy"
                      ></iframe>
                    </Grid>
                  </Grid>
                </Box>
              </div>
            </Container>

            <div className="newletter">
              <h2>Join Us</h2>
              <p>Stay up to date with our latest news</p>
              <div className="input-box">
                <input
                  placeholder="Enter Your Email Address"
                  onChange={e => {
                    setjoinEmail(e.target.value)
                  }}
                  value={joinEmail}
                  className="cus-input"
                  type="email"
                ></input>
                <button
                  type="button"
                  onClick={subscribe}
                  className={'submit-btn ' + classes.cusbtnbgcolor}
                >
                  Subscribe
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  )
}
function Item(props) {
  return (
    <div>
      <img src={props.item.image} width="100%"></img>
      <div style={{ marginTop: '-200px' }}></div>
    </div>
  )
}
export const getServerSideProps = getServerSideAPIProps('/store/[storeSlug]')